import styled from 'styled-components'
import Colors from 'utils/Colors'

export default styled.div`
  width: 85.5vw;
  height: 65vh;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1.5rem;
  box-shadow: 0px 1px 4px 1px rgb(0 0 0 / 20%);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${Colors.loginLigthenPrimaryColor};
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${Colors.loginPrimaryColor};
  }
`
export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`
export const NoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  
  & span {
    font-size: 2rem;
    color: ${Colors.gray}
  }
  
  & span:first-child {
    font-size: 8rem;
  }
`

export const Table = styled.table`
  width: 100%;
  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
  border-collapse: collapse;
  
  & thead tr {
    background-color: ${Colors.loginLigthenPrimaryColor} ;
    color: ${Colors.white};
    text-transform: uppercase;
    font-size: 1rem;
    & th {
      padding: 1rem;
      border-collapse: collapse;
      text-align: center;
    }
  }
  
  & tbody { 
    tr {
      background-color: ${Colors.white};
        
      &:nth-child(odd){
        background-color: ${Colors.lightGray} ;
      }
      
      &:hover {
        background-color: ${Colors.mediumLightGray};
      }
      
      & td {
        padding: 1rem;
        text-align: center;
        &.date-time {
          min-width: 220px;
          max-width: 220px; 
        }
      }
    }
`
